<template>
    <!-- O template HTML do seu componente -->
    <div>
        <Header :home="false" :arealogada="true"/>
        <div id="painel" class="container-fluid">
            <b-row>
                <b-col cols="12" md="4" lg="3" style="padding: 0;" class="espaco-menu">
                <Menu class="d-none d-xl-block" />
            </b-col>
            <b-col cols="12" md="8" lg="9" class="flex h-100 w-100 justify-content-center">
                <a style="display:block" :id="'download_boleto'" :download="'download_boleto'" />

                <b-container fluid id="painelcontainerfluid">
                    <b-row>
                        <b-col cols="10" style="padding: 0;">
                            <b-breadcrumb  :items="resolveBreadCrumb"></b-breadcrumb>
                        </b-col>
                        <b-col cols="2" style="padding: 0.75rem 1rem;" >
                            <b-link class="btn-voltar" href="/painel" style="text-decoration:none;font: normal normal bold 16px/24px 'Open Sans', sans-serif;color:#597EB5;">
                            Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                            </b-link>
                        </b-col>
                    </b-row>
                    <arealogadapesquisa @filtrarBusca="filtrarBusca" :resultado="items" :colunas="colunas" :colunasMobile="colunasMobile" :hasFilter="true" :page="'resolve'" :title="'Suas Solicitações'" />
                </b-container>
        </b-col>
      </b-row>
    </div>
        <footersite class="d-none d-xl-block" />
        <footersitemobile class="d-block d-xl-none"/>
    </div>
  </template>
  
  <script>

  import Header from '../components/Header'
  import Menu from '../template/Menu'
  import arealogada from "@/components/arealogada/index.vue";
  import arealogadapesquisa from "@/components/arealogada/pesquisa/index.vue";
  import footersite from "@/components/footersite";
  import footersitemobile from "@/components/footersite/index_mobile";
  import API from '../services/api'



  export default {
    components: {
      Header,
      Menu,
      arealogada,
      arealogadapesquisa,
      footersite,
      footersitemobile
    },
    data() {
      return {
        resolveBreadCrumb: [
            {text: 'Painel',href: "/painel" },
            {text: 'Pedidos Resolve',  active: true},
        ],
        colunas: [
          {label:'Nº Pedido',key:'cd_pedido',sortable:false,size:'0.5fr'},
          {label:'Solicitante',key:'nm_solicitante',sortable:false,size:'1.5fr'},
          {label:'Documento',key:'documento_pedido',sortable:true,size:'1fr'},
          {label:'Pesquisado',key:'nm_pesquisado',sortable:true,size:'1.5fr'},
          {label:'Tipo Pedido',key:'nm_produto',sortable:true,size:'1fr'},
          {label:'Data Pedido',key:'data_pedido',sortable:true,size:'1fr', isDate:true},
          {label:'Status',key:'status_pedido',sortable:true,size:'1fr'},
          {label:'Exibir',key:'details',sortable:false,size:'0.5fr'},
        ],
        colunasMobile: [
          {label:'Nº Pedido',key:'cd_pedido',sortable:false,size:'0.75fr'},
          {label:'Pesquisado',key:'nm_pesquisado',sortable:true,size:'1.5fr'},
          {key: "actions", label: "Exibir", sortable: false, size:"0.5fr"}
        ],
        form: {
            nrPedidoResolve: '',
        },
        items:[]
      };
    },
    // Métodos do componente
    methods: {
        filtrarBusca(filtros){
            this.form = {
                nrPedidoResolve:      (filtros.nrPedidoResolve !== null && filtros.nrPedidoResolve !== undefined ? filtros.nrPedidoResolve : ''),
            };
            this.get_resolve(nrPedidoResolve);
        },
        async get_resolve(){
            this.items = []
            this.loading = true;
            const token = localStorage.getItem('jwtToken')
            /*API.get(`certidao/consultaStatusBoleto?token=${token}`).then((resta) => {
                console.log(resta.data);
            });*/
            const res = await API.get(`certidao/usuario?token=${token}&nrPedidoResolve=${this.form.nrPedidoResolve}&tpPedido=3&primeiraBusca=${true}`)
            this.items = res.data
            this.loading = false;
        }
    }
  };
  </script>
  
  <style scoped>
  /* Estilos do componente (opcional) */

    .container-fluid {
        width: 100% !important;
    }
    .espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
    
    @media (max-width:1600px) and (min-width:1400px){
        .espaco-menu{margin-left: calc(20px - 5px) !important;}  
        #painelcontainerfluid{padding-right: 20px !important;}
    }
    @media (max-width:1399px) and (min-width:1200px){
        .espaco-menu{margin-left: calc(10px - 5px) !important;}
        #painelcontainerfluid{padding-right: 10px !important;}
    }

    #painel {
        position: fixed;
        width: 100%;
        left: 0px;
        bottom: 0px;
        padding-top: 0px;
        height: calc(100% - 109px);
        background-color: #ffffff;
        overflow-x: hidden;
        border-top: 1px solid #f1f1f1;
    }
    #painel > .row{justify-content: space-between;}
    #painel{scrollbar-width:none;}
    #painel::-webkit-scrollbar{display:none;}
    #painel h1 {text-align: left;font: normal normal bold 25px/41px 'Open Sans', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 22px;}

    .breadcrumb{margin-left: 0px;background: unset;}
    .breadcrumb a, .breadcrumb span, .breadcrumb-item + .breadcrumb-item::before{font: normal normal bold 16px/20px 'Open Sans', sans-serif;}
    .breadcrumb-item + .breadcrumb-item::before{float:unset;}
    .breadcrumb a{color:#597EB5;}
    .breadcrumb-item + .breadcrumb-item::before{color:#597EB5;}
    .breadcrumb span{color:#7e7e7e;}
    .breadcrumb a.disabled{text-decoration:none;cursor:default;}
    .btn-voltar {display: flex;align-items: center;margin-left: auto;letter-spacing: 0px;text-decoration: none;justify-content: flex-end !important;margin-bottom: 20px;}
    .btn-voltar img{width: 20px;height: 20px;margin-left: 6px;}
  </style>